export { default as Dialog } from './SimpleDialog';
